import { useEffect, useState } from 'react';
import { DEFAULT_SITE_SETTINGS, SiteSettings } from '../config/siteSettings';

let cachedSettings: SiteSettings | null = null;

export default function useSiteSettings(): SiteSettings {
  const [settings, setSettings] = useState<SiteSettings>(cachedSettings ?? DEFAULT_SITE_SETTINGS);

  useEffect(() => {
    fetch('/api/settings')
      .then(response => response.ok ? response.json() : Promise.reject())
      .then(data => {
        const nextSettings = { ...DEFAULT_SITE_SETTINGS, ...data };
        cachedSettings = nextSettings;
        setSettings(nextSettings);
      })
      .catch(() => {});
  }, []);

  return settings;
}
